module.exports = __webpack_public_path__ + "static/media/Volex_bild_LoggaIn.13e910c4.jpg";